import { useState } from 'react';

export default function Login({ onLogin, onShowSignup }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const r = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      if (r.ok) {
        onLogin();
      } else {
        setError('Incorrect credentials.');
      }
    } catch {
      setError('Connection error. Try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      height: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: 'var(--bg)',
    }}>
      <div className="fade-in" style={{
        background: 'var(--surface)',
        borderRadius: 'var(--radius-lg)',
        padding: '48px 40px',
        width: 360,
        boxShadow: 'var(--shadow-lg)',
        border: '1px solid var(--border)',
      }}>
        <h1 style={{
          fontFamily: 'var(--font-display)',
          fontSize: 32,
          marginBottom: 6,
        }}>Bearing360</h1>
        <p style={{ fontSize: 14, color: 'var(--muted)', marginBottom: 36, fontWeight: 300 }}>
          Personal Operating System
        </p>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            autoFocus
            style={inputStyle}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={inputStyle}
          />
          {error && (
            <p style={{ fontSize: 13, color: 'var(--danger)', textAlign: 'center' }}>{error}</p>
          )}
          <button
            type="submit"
            disabled={loading}
            style={{
              marginTop: 8,
              padding: '12px',
              background: 'var(--text)',
              color: '#fff',
              borderRadius: 'var(--radius-sm)',
              fontSize: 14,
              fontWeight: 500,
              opacity: loading ? 0.6 : 1,
              transition: 'opacity 0.15s',
            }}
          >{loading ? 'Signing in…' : 'Sign in'}</button>
        </form>

        {onShowSignup && (
          <p style={{ fontSize: 13, color: 'var(--muted)', textAlign: 'center', marginTop: 22 }}>
            No account?{' '}
            <button
              type="button"
              onClick={onShowSignup}
              style={{
                background: 'none', padding: 0, color: 'var(--text)',
                fontSize: 13, fontWeight: 500, textDecoration: 'underline', cursor: 'pointer',
              }}
            >Create one</button>
          </p>
        )}
      </div>
    </div>
  );
}

const inputStyle = {
  padding: '11px 14px',
  border: '1px solid var(--border)',
  borderRadius: 'var(--radius-sm)',
  fontSize: 14,
  background: 'var(--bg)',
  color: 'var(--text)',
  outline: 'none',
  width: '100%',
};
